<template>
    <div class="client-sort data-filter data-sort">
        <Form :label-width="100">
            <form-item :label="label">
                <Select :size="size" class="data-filter__select" :model-value="modelValue" @onChange="onChange">
                    <OptionGroup v-for="option in options" :key="option.field">
                        <Option
                            class="data-filter__option"
                            :value="option.ascValue"
                            :label="`${option.field} ${option.ascOptionDirection}`"
                        >
                            {{ option.field }}
                            <span class="data-sort__direction">
                                {{ option.ascOptionDirection }}
                            </span>
                        </Option>
                        <Option
                            class="data-filter__option"
                            :value="option.descValue"
                            :label="`${option.field} ${option.descOptionDirection}`"
                        >
                            {{ option.field }}
                            <span class="data-sort__direction">
                                {{ option.descOptionDirection }}
                            </span>
                        </Option>
                    </OptionGroup>
                </Select>
            </form-item>
        </Form>
    </div>
</template>

<script lang="ts">
export interface DataSortFilterOptions {
    field: string;
    ascValue: string;
    ascOptionDirection: string;
    descValue: string;
    descOptionDirection: string;
}
</script>

<script setup lang="ts">
interface Props {
    label: string;
    options: DataSortFilterOptions[];
    modelValue: string;
    size?: "large" | "default" | "small";
}

const { label, options, size, modelValue } = defineProps<Props>();

const emit = defineEmits(["update:modelValue"]);

function onChange(value: string) {
    emit("update:modelValue", value);
}
</script>
